var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.catalogError
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "text-center",
                      staticStyle: { padding: "15px" },
                      attrs: { show: "", variant: "danger" },
                    },
                    [_vm._v(" " + _vm._s(_vm.catalogError) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-row",
        { staticClass: "itens-container" },
        [
          _vm._l(_vm.catalog, function (product) {
            return _c(
              "b-col",
              {
                key: (product.kit ? "kit" : "product") + "-" + product.id,
                staticClass: "mb-2",
                attrs: { md: "3" },
              },
              [_c("item-card", { attrs: { product: product } })],
              1
            )
          }),
          _vm.catalogLoading
            ? _c(
                "b-col",
                { staticClass: "p-3 text-center", attrs: { md: "12" } },
                [
                  _c("b-spinner", {
                    staticClass: "mr-1",
                    attrs: { variant: "success", label: "Spinning" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.paging.allRowsLoaded
            ? _c(
                "b-col",
                { staticClass: "p-3 text-center", attrs: { md: "12" } },
                [_vm._v(" Todos os nossos produtos já foram carregados ")]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }